import './SmallScreenOverlay.scss'

import { HDSButton } from '@here/hds-react-components'
import { config } from 'lib/config'
import { i18n } from 'lib/i18n'
import React, { CSSProperties } from 'react'

const google = {
  link: 'https://play.google.com/store/apps/details?id=com.here.app.maps&pli=1',
  logo: `${config.ROOT_PATH}images/google-play.svg`,
}

const apple = {
  link: 'https://apps.apple.com/app/id955837609',
  logo: `${config.ROOT_PATH}images/app-store.svg`,
}

const learnLink = 'https://www.here.com/products/wego'

export const SmallScreenOverlay = (): JSX.Element => {
  const title = i18n('overlay.title')
  const description = i18n('overlay.description')
  const learnButton = i18n('overlay.learn')
  const handleOnClick = (): void => {
    window.open(learnLink, '_blank', 'noreferrer')
  }

  return (
    <div
      className="SmallScreenOverlay"
      style={
        {
          backgroundImage: `url("${config.ROOT_PATH}images/map_overlay.png")`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        } as CSSProperties
      }
    >
      <div className="SmallScreenOverlay__Overlay">
        <div className="SmallScreenOverlay__Card">
          <img
            src={`${config.ROOT_PATH}images/welcome-screen.svg`}
            alt="Welcome screen"
            className="SmallScreenOverlay__Thumbnail"
          />
          <div className="SmallScreenOverlay__Gradient" />
          <div className="SmallScreenOverlay__Wrapper">
            <h3 className="SmallScreenOverlay__Title">{title}</h3>
            <span className="SmallScreenOverlay__Description">{description}</span>
            <div className="SmallScreenOverlay__Buttons">
              <a href={apple.link} target="_blank" rel="noreferrer">
                <img className="SmallScreenOverlay__Button" src={apple.logo} alt="App store link" />
              </a>
              <a href={google.link} target="_blank" rel="noreferrer">
                <img
                  className="SmallScreenOverlay__Button"
                  src={google.logo}
                  alt="Google play link"
                />
              </a>
            </div>

            <hr className="SmallScreenOverlay__Divider" />

            <HDSButton
              size="large"
              variant="link"
              className="SmallScreenOverlay__Learn"
              onClick={handleOnClick}
            >
              {learnButton}
            </HDSButton>
          </div>
        </div>
      </div>
    </div>
  )
}
